import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class AppGroupService {
    async getAppGroups() {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AppGroup`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }

    async getSqlServerVersion(serverId: number) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AppGroup/${serverId}/sqlversion`;
        let response = await getAuthenticatedFetch()(url);
        return response.text();
    }

    async getCachedServiceHealthListByAppGroupName(appGrp: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/appGroup/${appGrp}/servicehealth`;
        let response = await getAuthenticatedFetch()(url);
        
        if (!response.ok) {
            throw new Error();
        }
        
        return await response.json();
    }

    async octopusSyncForAll() {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/appGroup/octopusSync`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST'
        });

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }
    
    async octopusSyncForAppGroup(appGrp: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/appGroup/${appGrp}/octopusSync`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST'
        });

        if (!response.ok) {
            throw new Error();
        }
        
        const jsonResponse = await response.json();

        if (!jsonResponse.success) {
            throw new Error();
        }
        
        return jsonResponse;
    }
}

export default new AppGroupService();
